var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7 0.7C7.7 0.313401 7.3866 1.04308e-08 7 1.04308e-08C6.6134 1.04308e-08 6.3 0.313401 6.3 0.7V9.1C6.3 9.4866 6.6134 9.8 7 9.8C7.3866 9.8 7.7 9.4866 7.7 9.1V0.7ZM1.4 9.1C1.4 8.7134 1.0866 8.4 0.7 8.4C0.313401 8.4 0 8.7134 0 9.1V11.9C0 12.457 0.221249 12.9911 0.615076 13.3849C1.0089 13.7788 1.54305 14 2.1 14H11.9C12.457 14 12.9911 13.7788 13.3849 13.3849C13.7788 12.9911 14 12.457 14 11.9V9.1C14 8.7134 13.6866 8.4 13.3 8.4C12.9134 8.4 12.6 8.7134 12.6 9.1V11.9C12.6 12.0857 12.5263 12.2637 12.395 12.395C12.2637 12.5263 12.0857 12.6 11.9 12.6H2.1C1.91435 12.6 1.7363 12.5263 1.60503 12.395C1.47375 12.2637 1.4 12.0857 1.4 11.9V9.1Z",
    fill: "#5B6885"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50503 0.205025C6.77839 -0.0683418 7.22161 -0.0683418 7.49497 0.205025L10.995 3.70503C11.2683 3.97839 11.2683 4.42161 10.995 4.69497C10.7216 4.96834 10.2784 4.96834 10.005 4.69497L7 1.68995L3.99498 4.69497C3.72161 4.96834 3.27839 4.96834 3.00503 4.69497C2.73166 4.42161 2.73166 3.97839 3.00503 3.70503L6.50503 0.205025Z",
    fill: "#5B6885"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.f0ed85a1.svg";
export { ForwardRef as ReactComponent };